// extracted by mini-css-extract-plugin
export default {"grid":"Services_grid__YOw9O","service":"Services_service__0IDuE","icon":"Services_icon__6aZ5N"};